import { listGroups } from '@/api/group-api';
import { useQuery } from '@tanstack/react-query';

export const groupKeys = {
  all: ['groups'] as const,
};

export const useGroups = () =>
  useQuery({
    queryKey: groupKeys.all,
    queryFn: listGroups,
    staleTime: 5 * 60 * 1000,
  });
